import { render, staticRenderFns } from "./Utilities-View-Downtime.vue?vue&type=template&id=6bf0169e"
import script from "./Utilities-View-Downtime.vue?vue&type=script&lang=js"
export * from "./Utilities-View-Downtime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports